<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'服務紀錄範本類別列表'"></page-title>
        </div>
        <div class="md-layout-item float-right">
          <md-button class="md-raised md-primary float-right" @click="$router.push('/record-template-group/add')">新增服務紀錄範本類別</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>服務紀錄範本類別名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="clearAll">清除搜尋結果</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="getRecordTemplateGroups()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
            </md-table-row>
            <md-table-row v-for="(recordTemplateGroup, index) in recordTemplateGroups" :recordTemplateGroups="recordTemplateGroups" :key="recordTemplateGroup.id">
              <md-table-cell>
                <router-link :to="`/record-template-group/${recordTemplateGroup.id}/list`">
                  {{recordTemplateGroup.name}}
                </router-link>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getRecordTemplateGroups"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import urls from '@/urls'
import axios from 'axios'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      recordTemplateGroups: []
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.getRecordTemplateGroups()
  },
  methods: {
    clearAll: async function () {
      this.recordTemplateGroups = []
      this.data.name = null
    },
    getRecordTemplateGroups: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: 'record-template-group'}), {params: {...this.data, page}})
      this.recordTemplateGroups = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RecordTemplateGroup/RecordTemplateGroupList.vue